// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2cb5acde","453":"711371f6","455":"324c9c31","977":"75ceac9d"}[chunkId] + ".chunk.js";
};